
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'FormField',
  props: {
    errCondition: {
      type: Boolean,
      required: true
    },
    errMsg: {
      type: String,
      default: 'This is a required field.'
    },
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  }
})
